import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

const LANGS = ['th', 'en']
const DEFAULT_LANG = LANGS[0]

export const useLangStore = defineStore('app/lang', () => {
  // State -----------------------------------------
  const lang = ref(DEFAULT_LANG)

  // Getters ---------------------------------------

  // Actions ---------------------------------------
  function $reset() {
    lang.value = DEFAULT_LANG
  }

  function changeLang(name) {
    lang.value = LANGS.includes(name) ? name : DEFAULT_LANG
    // document.documentElement.setAttribute('lang', lang.value)
  }

  function switchLang() {
    changeLang(lang.value == LANGS[0] ? LANGS[1] : LANGS[0])
  }

  // Main Setup ------------------------------------

  // -----------------------------------------------
  return { lang, $reset, changeLang, switchLang }
})
